export default "__VITE_ASSET___2wvCrCr__"